<template>
	<div>
		<div v-if="canSave">
			<v-combobox :label="$t('pages.anotherDescription')" :items="options" item-text="text" v-model="listValue" @input="changeInput" required>
				<template v-slot:append>
					<v-icon x-small color="red lighten-2">mdi-asterisk</v-icon>
				</template>
			</v-combobox>
		</div>
		<div v-else>
			<p></p>
			<v-autocomplete :label="$t('pages.measurmentArea.Choosewhatmeasure')" :items="options" item-text="text" v-model="listValue" @input="changeInput" required>
				<template v-slot:append>
					<v-icon x-small color="red lighten-2">mdi-asterisk</v-icon>
				</template>
			</v-autocomplete>
		</div>
		<div v-if="listValue && outFromList">
			<smart-input maxlength="30" :counter="true" required :label="$t('pages.measurmentArea.Choosewhatmeasure')" v-model.lazy="valueNotInList" @change="onBlur"></smart-input>
		</div>
	</div>
</template>

<script>

	import json from "src/lists/area-list";
	import {types} from "src/store/modules/Area.module";

	export default {
		name: "area-select",
		props: {value: {default: null}, canSave: {default: false}},
		data() {
			return {
				options: [],
				listValue: null,
				valueNotInList: null
				// model: null,
			};
		},
		methods: {
			inList(value) {
				if (!this.options.length) {
					this.options = this.defaultOptions;
				}
				return this.options.includes(value);
			},
			changeInput() {
				this.$emit("input", this.listValue);
			},
			onBlur() {
				this.model = this.valueNotInList;
			}
		},
		computed: {
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
			outFromList() {
				return this.listValue === "אחר";
			},
			defaultOptions() {
				const areas = this.$store.state.AreaModule.areas.map((area) => area.name);

				return (areas.length ? areas : json).concat(["אחר"]).sort();
			},

		},
		created() {
			this.$store.dispatch(types.FETCH).then(() => {
				this.options = this.defaultOptions;
			}, () => {
				this.options = this.defaultOptions;
			});
		},
		watch: {
			value: {
				immediate: true,
				handler() {
					if (this.inList(this.value)) {
						this.listValue = this.value;
					} else if (this.value) {
						this.listValue = "אחר";
						this.valueNotInList = this.value;
					}
				}
			}
		}
	};
</script>

<style scoped>

p {
  padding-top: 18px;
  font-size: 16px;
}
</style>
